import { ConnectorUpdate } from '@web3-react/types'
import { AbstractConnector } from '@web3-react/abstract-connector'
import { WsProvider, Keyring } from "@polkadot/api"
import { TypeRegistry } from "@polkadot/types"
import { Provider as ReefProvider, Signer } from "@reef-defi/evm-provider";
import { KeyringPair } from "@polkadot/keyring/types";
import {
    web3Accounts,
    web3Enable,
} from "@polkadot/extension-dapp";
export const URI_AVAILABLE = 'URI_AVAILABLE'

export class UserRejectedRequestError extends Error {
    public constructor() {
        super()
        this.name = this.constructor.name
        this.message = 'The user rejected the request.'
    }
}

// function getSupportedChains({ supportedChainIds, rpc }: WalletConnectConnectorArguments): number[] | undefined {
//     if (supportedChainIds) {
//         return supportedChainIds
//     }

//     return rpc ? Object.keys(rpc).map(k => Number(k)) : undefined
// }
export class PolkajsConnector extends AbstractConnector {
    // private readonly config: string

    public polkajsProvider?: any
    public wallet?: any
    constructor(config: string) {
        super({ supportedChainIds: [13939] })

        // this.config = config

        this.handleChainChanged = this.handleChainChanged.bind(this)
        this.handleAccountsChanged = this.handleAccountsChanged.bind(this)
        this.handleDisconnect = this.handleDisconnect.bind(this)
    }

    private handleChainChanged(chainId: number | string): void {
        // if (__DEV__) {
        //   console.log("Handling 'chainChanged' event with payload", chainId)
        // }
        this.emitUpdate({ chainId })
    }

    private handleAccountsChanged(accounts: string[]): void {
        // if (__DEV__) {
        //   console.log("Handling 'accountsChanged' event with payload", accounts)
        // }
        this.emitUpdate({ account: accounts[0] })
    }

    private handleDisconnect(): void {
        // if (__DEV__) {
        //   console.log("Handling 'disconnect' event")
        // }
        this.emitDeactivate()
        // we have to do this because of a @walletconnect/web3-provider bug
        if (this.polkajsProvider) {
            // this.polkajsProvider?.removeListener('chainChanged', this.handleChainChanged)
            // this.polkajsProvider?.removeListener('accountsChanged', this.handleAccountsChanged)
            this.polkajsProvider = undefined
        }

        this.emitDeactivate()
    }

    public async activate(): Promise<ConnectorUpdate> {
        let account = "";
        if (!this.polkajsProvider) {
            const extensions = await web3Enable("reef.kwikswap")

            const accounts = await web3Accounts();
            const storageselectedaccount = localStorage.getItem("selectedaccount");
            const selectedaccount = accounts.find(acc => acc.address === storageselectedaccount);
            if (accounts.length > 0 && (selectedaccount || accounts[0].address)) {
                const provider = new ReefProvider({
                    provider: new WsProvider('wss://rpc-testnet.reefscan.com/ws'),
                    registry: new TypeRegistry(),
                    signer: extensions[0]?.signer,

                })
                await provider.api.isReady;

                let pair: KeyringPair;
                const keyring = new Keyring({ type: "sr25519" });
                pair = keyring.addFromAddress(selectedaccount ? selectedaccount?.address : accounts[0].address);


                const wallet = new Signer(provider, pair.address, extensions[0].signer);
                this.wallet = wallet
                if (!(await wallet.isClaimed())) {
                    await wallet.getAddress()
                    await wallet.claimDefaultAccount()
                }
                // Claim default account
                account = await wallet.getAddress();
                //@ts-ignore
                window.provider = provider
                this.polkajsProvider = provider;
            }
        }

        return { provider: this.polkajsProvider, account }
    }

    public async getProvider(): Promise<any> {
        return this.polkajsProvider
    }

    public async getChainId(): Promise<number | string> {
        const network = await this.polkajsProvider.getNetwork()
        return network.chainId
    }

    public async getAccount(): Promise<null | string> {
        let account = "";

        account = await this.wallet.getAddress();
        return account;
    }

    public deactivate() {
        if (this.polkajsProvider) {
            // this.polkajsProvider?.removeListener('disconnect', this.handleDisconnect)
            // this.polkajsProvider?.removeListener('chainChanged', this.handleChainChanged)
            // this.polkajsProvider?.removeListener('accountsChanged', this.handleAccountsChanged)
        }
    }

    public async close() {
        // await this.polkajsProvider?.close()
    }
}